import { NgModule } from '@angular/core';
import { SanitizeHtmlPipe } from './shared/services/safe.pipe';

@NgModule({
    declarations: [SanitizeHtmlPipe],
    exports: [SanitizeHtmlPipe],
})
export class SanitizeHtmlModule {}
